import { api } from "@/lib/api";

export type AccountChannel = {
  id: "wecom" | "sms" | "email" | string;
  label: string;
  enabled: boolean;
  status: "ready" | "not_ready" | "coming_soon" | string;
  coming_soon: boolean;
};

export type AccountChannelsResponse = {
  channels: AccountChannel[];
};

/** 拉取账户可选触达渠道（含即将上线占位） */
export async function fetchAccountChannels(accountId: string | number) {
  return api.fetchForAccount<AccountChannelsResponse>(accountId, "/account/channels");
}

export function enabledChannelIds(channels: AccountChannel[]): string[] {
  return channels.filter((c) => c.enabled).map((c) => c.id);
}
